/** Dinero en centavos enteros: nunca se usan decimales de punto flotante para guardar montos. */

export function formatMoney(cents: number, currency: string): string {
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency }).format(cents / 100);
}

/** "1,234.5" → 123450. Acepta separador de miles con coma y hasta dos decimales. Null si no es válido. */
export function parseMoney(text: string): number | null {
  const clean = text.trim().replace(/[$\s]/g, '').replace(/,/g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(clean)) return null;
  const [whole, fraction = ''] = clean.split('.');
  const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  return cents > 0 && Number.isSafeInteger(cents) ? cents : null;
}

/** "2026-09-25" → "25 sep 2026" sin corrimiento de zona horaria. */
export function formatDay(isoDate: string): string {
  const [y, m, d] = isoDate.split('-').map(Number);
  return new Date(Date.UTC(y!, m! - 1, d!)).toLocaleDateString('es', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

/** Primer día del mes de una fecha AAAA-MM-DD. */
export const monthStart = (isoDate: string) => `${isoDate.slice(0, 7)}-01`;

export const ACCOUNT_KIND: Record<'cash' | 'bank' | 'fund', string> = { cash: 'Efectivo', bank: 'Banco', fund: 'Fondo' };
